<template>
    <div>
        <Header />
        <div class="top-holder">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="top-left">
                            <h6>Driving Real Impact Through Housing.</h6>
                            <h3>Empowering Organizations, Cooperatives and Institutions to Care, Grow and Thrive.</h3>
                            <p>Shelta for Corporate is a powerful platform designed for organizations, cooperatives, associations, schools and institutions to provide real value, financial relief and long-term stability for their people.</p>

                            <div class="join-btn d-none d-sm-block">
                                <button class="btn" @click="moveToRouteName('https://corporate.myshelta.com/dashboard')">Get started</button>
                                <button class="btn no-button">Learn how it works</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <img class="w-100" src="../assets/home/cooperate-hero.png" alt="cooperate">

                        </div>
                    </div>
                </div>
                <div class="count-holder">
                    <div class="row">
                        <div class="col-md-6 item-count">
                            <div class="row">
                                <div class="col-md-6 first-col">
                                    <h2>90%</h2>
                                    <p>Reduction in rent stress</p>
                                </div>
                                <div class="col-md-6">
                                    <h2>50+</h2>
                                    <p>Corporate & Merchant Partners</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="join-btn d-block d-sm-none mt-5">
                        <button class="btn">Get started</button>
                        <button class="btn no-button">Learn how it works</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="holding container">    
            <div class="partners-holder">
                <h6>Powered by trusted partners and organizations building better living across Africa.</h6>
                <div class=" mt-5 scroller">
                    <ul class="scroller-inner">
                        <li>
                            <img src="../assets/brands/ppdc.png" alt="ppdc">
                        </li>
                        <li>
                            <img src="../assets/brands/dojan.png" alt="dojan">
                        </li>
                        <li>
                            <img src="../assets/brands/squad.png" alt="squad">
                        </li>
                        <li>
                            <img src="../assets/brands/first-central.png" alt="firstbank">
                        </li>
                        <li>
                            <img src="../assets/brands/interswitch.png" alt="interswitch">
                        </li>
                        <li>
                            <img src="../assets/brands/hxafrica.png" alt="hxafrica">
                        </li>
                        <li>
                            <img src="../assets/brands/tree.png" alt="tree">
                        </li>
                    </ul>
                    
                </div>
            </div>
        </div>
        <div style="background: #F8F9FA;">
            <div class="solved-problem container">
                <h3>Everything Your Organization Needs</h3>
                <h6>Tailored solutions for employers, cooperatives, and associations</h6>

                <div class="problem-cover">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="problem-item">
                                <span>
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                        <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                        <path d="M27.5 25C31.0899 25 34 24.1046 34 23C34 21.8954 31.0899 21 27.5 21C23.9101 21 21 21.8954 21 23C21 24.1046 23.9101 25 27.5 25Z" stroke="#0033EA" stroke-width="1.5"/>
                                        <path d="M34 27.5C34 28.6046 31.0899 29.5 27.5 29.5C23.9101 29.5 21 28.6046 21 27.5" stroke="#0033EA" stroke-width="1.5"/>
                                        <path d="M34 23V31.8C34 33.015 31.0899 34 27.5 34C23.9101 34 21 33.015 21 31.8V23" stroke="#0033EA" stroke-width="1.5"/>
                                        <path d="M20.5 18C24.0899 18 27 17.1046 27 16C27 14.8954 24.0899 14 20.5 14C16.9101 14 14 14.8954 14 16C14 17.1046 16.9101 18 20.5 18Z" stroke="#0033EA" stroke-width="1.5"/>
                                        <path d="M18 23C16.1082 22.7698 14.3699 22.1745 14 21M18 28C16.1082 27.7698 14.3699 27.1745 14 26" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M18 33C16.1082 32.7698 14.3699 32.1745 14 31V16" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M27 18V16" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                    </svg>

                                </span>
                                <h5>Flexible Rent & Home Access</h5>
                                <p>Enable members or staff to pay rent flexibly while landlords get paid upfront.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="problem-item">
                                <span>
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                        <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                        <path d="M24.8924 14.8098L33.4876 21.5955C33.8112 21.851 34 22.2405 34 22.6528C34 23.3969 33.3969 24 32.6528 24H32V27.5C32 30.3284 32 31.7426 31.1213 32.6213C30.2426 33.5 28.8284 33.5 26 33.5H22C19.1716 33.5 17.7574 33.5 16.8787 32.6213C16 31.7426 16 30.3284 16 27.5V24H15.3472C14.6032 24 14 23.3969 14 22.6528C14 22.2405 14.1888 21.851 14.5124 21.5955L23.1076 14.8098C23.3617 14.6091 23.6761 14.5 24 14.5C24.3239 14.5 24.6383 14.6091 24.8924 14.8098Z" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26.5 33.5V29C26.5 28.0654 26.5 27.5981 26.299 27.25C26.1674 27.022 25.978 26.8326 25.75 26.701C25.4019 26.5 24.9346 26.5 24 26.5C23.0654 26.5 22.5981 26.5 22.25 26.701C22.022 26.8326 21.8326 27.022 21.701 27.25C21.5 27.5981 21.5 28.0654 21.5 29V33.5" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h5>Affordable Housing & Mortgage </h5>
                                <p>Connect employees or members to verified rent-to-own and cooperative housing projects.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="problem-item">
                                <span>
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                        <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                        <path d="M21.3359 40.8624V26.7403C21.3359 22.935 21.3359 21.0323 22.5075 19.8501C23.6791 18.668 25.5647 18.668 29.3359 18.668H34.6693C38.4405 18.668 40.3261 18.668 41.4977 19.8501C42.6693 21.0323 42.6693 22.935 42.6693 26.7403V40.8624C42.6693 42.878 42.6693 43.8857 42.0533 44.2824C41.0467 44.9308 39.4907 43.5712 38.7081 43.0777C38.0614 42.6698 37.7382 42.466 37.3793 42.4542C36.9915 42.4414 36.6625 42.637 35.9638 43.0777L33.4159 44.6845C32.7286 45.1178 32.385 45.3346 32.0026 45.3346C31.6202 45.3346 31.2766 45.1178 30.5893 44.6845L28.0414 43.0777C27.3948 42.6698 27.0715 42.466 26.7126 42.4542C26.3249 42.4414 25.9958 42.637 25.2971 43.0777C24.5145 43.5712 22.9584 44.9308 21.9519 44.2824C21.3359 43.8857 21.3359 42.878 21.3359 40.8624Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M30.6641 30.668H26.6641" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M34.6641 25.332H26.6641" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h5>Payroll Integration</h5>
                                <p>Automated deductions and contribution management for rent, mortgage, or savings.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="problem-item">
                                <span>
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                        <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                        <path d="M39.2799 28.1069L38.8918 27.4216C38.5983 26.9033 38.4515 26.6442 38.2018 26.5409C37.9522 26.4375 37.6697 26.5191 37.1049 26.6821L36.1454 26.9571C35.7847 27.0417 35.4065 26.9937 35.0771 26.8216L34.8122 26.6661C34.5299 26.4821 34.3127 26.2108 34.1925 25.8919L33.9299 25.094C33.7573 24.566 33.6709 24.302 33.4654 24.151C33.2599 24 32.9869 24 32.4409 24H31.5643C31.0183 24 30.7453 24 30.5398 24.151C30.3343 24.302 30.2479 24.566 30.0753 25.094L29.8127 25.8919C29.6925 26.2108 29.4753 26.4821 29.193 26.6661L28.9281 26.8216C28.5988 26.9937 28.2204 27.0417 27.8598 26.9571L26.9003 26.6821C26.3355 26.5191 26.0531 26.4375 25.8034 26.5409C25.5536 26.6442 25.4069 26.9033 25.1133 27.4216L24.7252 28.1069C24.4501 28.5927 24.3125 28.8356 24.3392 29.0941C24.3659 29.3527 24.5501 29.5611 24.9184 29.9779L25.7292 30.9C25.9273 31.1552 26.068 31.6 26.068 31.9999C26.068 32.4 25.9273 32.8447 25.7292 33.0999L24.9184 34.0221C24.5501 34.4388 24.3659 34.6472 24.3392 34.9057C24.3125 35.1644 24.4501 35.4073 24.7252 35.8931L25.1133 36.5783C25.4069 37.0965 25.5536 37.3557 25.8034 37.4591C26.0531 37.5624 26.3355 37.4808 26.9004 37.3177L27.8598 37.0428C28.2205 36.9581 28.5989 37.0063 28.9282 37.1784L29.1931 37.3339C29.4754 37.5179 29.6925 37.7892 29.8127 38.108L30.0753 38.906C30.2479 39.434 30.3343 39.698 30.5398 39.8489C30.7453 40 31.0183 40 31.5643 40H32.4409C32.9869 40 33.2599 40 33.4654 39.8489C33.6709 39.698 33.7573 39.434 33.9299 38.906L34.1925 38.108C34.3127 37.7892 34.5298 37.5179 34.8122 37.3339L35.077 37.1784C35.4063 37.0063 35.7847 36.9581 36.1454 37.0428L37.1049 37.3177C37.6697 37.4808 37.9521 37.5624 38.2018 37.4591C38.4515 37.3557 38.5983 37.0965 38.8919 36.5784L39.2799 35.8931C39.5551 35.4073 39.6927 35.1644 39.6659 34.9057C39.6393 34.6472 39.4551 34.4388 39.0867 34.0221L38.2761 33.0999C38.0778 32.8447 37.9373 32.4 37.9373 31.9999C37.9373 31.6 38.0779 31.1552 38.2761 30.9L39.0867 29.9779C39.4551 29.5611 39.6393 29.3527 39.6659 29.0941C39.6927 28.8356 39.5551 28.5927 39.2799 28.1069Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                        <path d="M31.9974 34.3346C33.2861 34.3346 34.3307 33.29 34.3307 32.0013C34.3307 30.7126 33.2861 29.668 31.9974 29.668C30.7087 29.668 29.6641 30.7126 29.6641 32.0013C29.6641 33.29 30.7087 34.3346 31.9974 34.3346Z" stroke="#0033EA" stroke-width="2"/>
                                        <path d="M41.3307 18.668V22.4794C38.9257 20.1217 35.6314 18.668 31.9974 18.668C24.6336 18.668 18.6641 24.6375 18.6641 32.0013C18.6641 33.8976 19.0599 35.7014 19.7735 37.3346M22.6641 45.3346V41.5232C25.0691 43.8809 28.3635 45.3346 31.9974 45.3346C39.3611 45.3346 45.3307 39.365 45.3307 32.0013C45.3307 30.105 44.9349 28.3012 44.2213 26.668" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h5>Cooperative & Association Tools</h5>
                                <p>Digitize savings, investments and project funding with transparent dashboards.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="problem-item">
                                <span>
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                        <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                        <path d="M28 42.668C22.9719 41.5104 20 36.9042 20 32.6816C20 27.6606 24.4935 22.6989 27.6475 19.8346C29.3605 18.2791 31.9729 18.2791 33.6857 19.8346C35.6949 21.6591 38.0999 24.3348 39.6681 27.3346" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                        <path d="M38.6641 36.6679C36.6641 38.0013 33.3307 40.6679 30.6641 45.3346M33.3307 41.3346C29.779 33.5222 37.1103 30.9819 42.5639 30.689C43.2221 30.6537 43.5511 30.6359 43.7874 30.8639C44.0238 31.0918 44.0101 31.4167 43.9829 32.0666C43.7566 37.4702 41.3237 44.8103 33.3307 41.3346Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                </span>
                                <h5>Household Services Access</h5>
                                <p>Members enjoy on-demand access to Fixr home services, Watt SOLLAA energy and Shelta Renovate.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="problem-item">
                                <span>
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                        <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                        <path d="M30 27.6667V25C30 22.8083 30 21.7125 29.3947 20.9749C29.2839 20.8399 29.1601 20.7161 29.0251 20.6053C28.2875 20 27.1917 20 25 20C22.8083 20 21.7125 20 20.9749 20.6053C20.8399 20.7161 20.7161 20.8399 20.6053 20.9749C20 21.7125 20 22.8083 20 25V27.6667C20 29.8583 20 30.9541 20.6053 31.6917C20.7161 31.8268 20.8399 31.9505 20.9749 32.0613C21.7125 32.6667 22.8083 32.6667 25 32.6667C27.1917 32.6667 28.2875 32.6667 29.0251 32.0613C29.1601 31.9505 29.2839 31.8268 29.3947 31.6917C30 30.9541 30 29.8583 30 27.6667Z" stroke="#0033EA" stroke-width="2" stroke-linejoin="round"/>
                                        <path d="M26.3333 36.668H23.6667C22.7363 36.668 22.2711 36.668 21.8926 36.7828C21.0403 37.0413 20.3734 37.7082 20.1148 38.5605C20 38.939 20 39.4042 20 40.3346C20 41.265 20 41.7302 20.1148 42.1088C20.3734 42.961 21.0403 43.628 21.8926 43.8865C22.2711 44.0013 22.7363 44.0013 23.6667 44.0013H26.3333C27.2637 44.0013 27.7289 44.0013 28.1074 43.8865C28.9597 43.628 29.6267 42.961 29.8852 42.1088C30 41.7302 30 41.265 30 40.3346C30 39.4042 30 38.939 29.8852 38.5605C29.6267 37.7082 28.9597 37.0413 28.1074 36.7828C27.7289 36.668 27.2637 36.668 26.3333 36.668Z" stroke="#0033EA" stroke-width="2" stroke-linejoin="round"/>
                                        <path d="M44 38.9987V36.332C44 34.1404 44 33.0446 43.3947 32.307C43.2839 32.1719 43.1601 32.0482 43.0251 31.9374C42.2875 31.332 41.1916 31.332 39 31.332C36.8084 31.332 35.7125 31.332 34.9749 31.9374C34.8399 32.0482 34.7161 32.1719 34.6053 32.307C34 33.0446 34 34.1404 34 36.332V38.9987C34 41.1903 34 42.2862 34.6053 43.0238C34.7161 43.1588 34.8399 43.2826 34.9749 43.3934C35.7125 43.9987 36.8084 43.9987 39 43.9987C41.1916 43.9987 42.2875 43.9987 43.0251 43.3934C43.1601 43.2826 43.2839 43.1588 43.3947 43.0238C44 42.2862 44 41.1903 44 38.9987Z" stroke="#0033EA" stroke-width="2" stroke-linejoin="round"/>
                                        <path d="M40.3333 20H37.6667C36.7363 20 36.2711 20 35.8925 20.1148C35.0403 20.3734 34.3733 21.0403 34.1148 21.8926C34 22.2711 34 22.7363 34 23.6667C34 24.597 34 25.0622 34.1148 25.4408C34.3733 26.293 35.0403 26.96 35.8925 27.2185C36.2711 27.3333 36.7363 27.3333 37.6667 27.3333H40.3333C41.2637 27.3333 41.7289 27.3333 42.1075 27.2185C42.9597 26.96 43.6267 26.293 43.8852 25.4408C44 25.0622 44 24.597 44 23.6667C44 22.7363 44 22.2711 43.8852 21.8926C43.6267 21.0403 42.9597 20.3734 42.1075 20.1148C41.7289 20 41.2637 20 40.3333 20Z" stroke="#0033EA" stroke-width="2" stroke-linejoin="round"/>
                                    </svg>

                                </span>
                                <h5>Data & Analytics Dashboard</h5>
                                <p>Gain insights into housing, welfare and engagement metrics across your organization.</p>
                            </div>
                        </div>
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="problem-item">
                                        <span>
                                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M34 45.332H29.3333C24.9336 45.332 22.7337 45.332 21.3668 43.9652C20 42.5983 20 40.3984 20 35.9987V30.6654C20 28.1512 20 26.8941 20.7811 26.1131C21.5621 25.332 22.8192 25.332 25.3333 25.332H36C38.5141 25.332 39.7712 25.332 40.5523 26.1131C41.3333 26.8941 41.3333 28.1512 41.3333 30.6654V31.9987" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M36.0026 28.668C36.0026 23.5133 33.6147 18.668 30.6693 18.668C27.7238 18.668 25.3359 23.5133 25.3359 28.668" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M42.9817 36.6979C42.1407 36.2584 41.1115 36 40 36C38.8885 36 37.8593 36.2584 37.0183 36.6979C36.6059 36.9133 36.3996 37.0211 36.1999 37.3597C36 37.6985 36 38.0265 36 38.6824V40.3107C36 42.9629 38.0188 44.4375 39.188 45.0691C39.5141 45.2452 39.6771 45.3333 40 45.3333C40.3229 45.3333 40.4859 45.2452 40.812 45.0691C41.9812 44.4375 44 42.9629 44 40.3107V38.6825C44 38.0265 44 37.6985 43.8001 37.3597C43.6004 37.0211 43.3941 36.9133 42.9817 36.6979Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <h5>Brand Visibility</h5>
                                        <p>Organizations and cooperatives gain access to Shelta’s growing household community for visibility and partnership.</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="problem-item">
                                        <span>
                                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M38.6641 38.6667C36.8231 38.6667 35.3307 37.1743 35.3307 35.3333C35.3307 33.4924 36.8231 32 38.6641 32C40.505 32 41.9974 33.4924 41.9974 35.3333C41.9974 37.1743 40.505 38.6667 38.6641 38.6667ZM38.6641 38.6667C41.9778 38.6667 44.6641 41.3529 44.6641 44.6667M38.6641 38.6667C35.3503 38.6667 32.6641 41.3529 32.6641 44.6667" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M25.3359 25.9987C23.495 25.9987 22.0026 24.5063 22.0026 22.6654C22.0026 20.8244 23.495 19.332 25.3359 19.332C27.1769 19.332 28.6693 20.8244 28.6693 22.6654C28.6693 24.5063 27.1769 25.9987 25.3359 25.9987ZM25.3359 25.9987C28.6496 25.9987 31.3359 28.685 31.3359 31.9987M25.3359 25.9987C22.0222 25.9987 19.3359 28.685 19.3359 31.9987" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M20.6641 36.668C20.6641 40.3537 23.645 43.3346 27.3307 43.3346L26.6641 40.668" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M40.6667 27.3346C40.6667 23.6489 37.6857 20.668 34 20.668L34.6667 23.3346" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <h5>Community Impact Linkage</h5>
                                        <p>Tie corporate social responsibility (CSR) goals to Shelta Impact Projects (SIP) — from repairs to children’s programs.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="container">
            <div class="why-matters-holder">
                <div class="row">
                    <div class="col-md-6">
                        <div class="matters-item">
                            <h2>Why It Matters</h2>
                            <p class="mb-4">In Africa, home ownership is not just a goal - it is a cultural aspiration. Yet millions of employees and members remain trapped in the cycle of lump-sum rent, debt and uncertainty.</p>
                            <small>Shelta for Corporate changes that:</small>
                            <p>It helps organizations become enablers of affordable housing, rent flexibility and household stability, all while improving welfare, retention and productivity.</p>

                            <div class="primary-button">
                                <button class="btn" @click="moveToRouteName('https://corporate.myshelta.com/auth')">Get Started</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="org-partner">
                            <h6>When organizations partner with Shelta, they:</h6>
                            <div class="org-partner-item">
                                <div class="d-flex">
                                    <div>
                                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M29.8359 13.8928C28.1199 12.9002 26.1276 12.332 24.0026 12.332C17.5593 12.332 12.3359 17.5554 12.3359 23.9987C12.3359 30.442 17.5593 35.6654 24.0026 35.6654C30.4459 35.6654 35.6693 30.442 35.6693 23.9987C35.6693 23.1996 35.5889 22.4193 35.4359 21.6654" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                            <path d="M19.3359 24.582C19.3359 24.582 21.0859 24.582 23.4193 28.6654C23.4193 28.6654 29.9045 17.9709 35.6693 15.832" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <p>Empower their people to access rent or home ownership without financial stress.</p>
                                </div>
                            </div>
                            <div class="org-partner-item">
                                <div class="d-flex">
                                    <div>
                                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M29.8359 13.8928C28.1199 12.9002 26.1276 12.332 24.0026 12.332C17.5593 12.332 12.3359 17.5554 12.3359 23.9987C12.3359 30.442 17.5593 35.6654 24.0026 35.6654C30.4459 35.6654 35.6693 30.442 35.6693 23.9987C35.6693 23.1996 35.5889 22.4193 35.4359 21.6654" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                            <path d="M19.3359 24.582C19.3359 24.582 21.0859 24.582 23.4193 28.6654C23.4193 28.6654 29.9045 17.9709 35.6693 15.832" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <p>Enhance loyalty and performance through welfare that actually matters.</p>
                                </div>
                            </div>
                            <div class="org-partner-item">
                                <div class="d-flex">
                                    <div>
                                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M29.8359 13.8928C28.1199 12.9002 26.1276 12.332 24.0026 12.332C17.5593 12.332 12.3359 17.5554 12.3359 23.9987C12.3359 30.442 17.5593 35.6654 24.0026 35.6654C30.4459 35.6654 35.6693 30.442 35.6693 23.9987C35.6693 23.1996 35.5889 22.4193 35.4359 21.6654" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                            <path d="M19.3359 24.582C19.3359 24.582 21.0859 24.582 23.4193 28.6654C23.4193 28.6654 29.9045 17.9709 35.6693 15.832" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <p>Integrate financially into Africa’s fastest-growing household ecosystem.</p>
                                </div>
                            </div>
                            <div class="org-partner-item">
                                <div class="d-flex">
                                    <div>
                                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M29.8359 13.8928C28.1199 12.9002 26.1276 12.332 24.0026 12.332C17.5593 12.332 12.3359 17.5554 12.3359 23.9987C12.3359 30.442 17.5593 35.6654 24.0026 35.6654C30.4459 35.6654 35.6693 30.442 35.6693 23.9987C35.6693 23.1996 35.5889 22.4193 35.4359 21.6654" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                            <path d="M19.3359 24.582C19.3359 24.582 21.0859 24.582 23.4193 28.6654C23.4193 28.6654 29.9045 17.9709 35.6693 15.832" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <p>Gain visibility among thousands of households using Shelta every day.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="built-for-org-holder">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="built-item-left">
                            <h2>Built for Organizations That Want Real Efficiency and Impact</h2>
                            <p>From rent programs to welfare contributions, Shelta for Corporate brings your housing and staff benefit operations under one powerful platform — automated, transparent, and human-centered.</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="built-item-right">
                                    <div class="span-svg">
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M36.6667 33.3333C41.4531 33.3333 45.3333 32.1394 45.3333 30.6667C45.3333 29.1939 41.4531 28 36.6667 28C31.8802 28 28 29.1939 28 30.6667C28 32.1394 31.8802 33.3333 36.6667 33.3333Z" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M45.3333 36.668C45.3333 38.1408 41.4532 39.3346 36.6667 39.3346C31.8801 39.3346 28 38.1408 28 36.668" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M45.3333 30.668V42.4013C45.3333 44.0213 41.4532 45.3346 36.6667 45.3346C31.8801 45.3346 28 44.0213 28 42.4013V30.668" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M27.3307 24.0013C32.1172 24.0013 35.9974 22.8074 35.9974 21.3346C35.9974 19.8619 32.1172 18.668 27.3307 18.668C22.5443 18.668 18.6641 19.8619 18.6641 21.3346C18.6641 22.8074 22.5443 24.0013 27.3307 24.0013Z" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M23.9974 30.6667C21.475 30.3597 19.1573 29.566 18.6641 28M23.9974 37.3333C21.475 37.0264 19.1573 36.2327 18.6641 34.6667" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M23.9974 43.9987C21.475 43.6918 19.1573 42.898 18.6641 41.332V21.332" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M36 23.9987V21.332" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </div>
                                    <h5>Corporate Dashboard</h5>
                                    <small>Centralized control for rent programs, housing projects and contributions.</small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="built-item-right">
                                    <div class="span-svg">
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M36.6667 33.3333C41.4531 33.3333 45.3333 32.1394 45.3333 30.6667C45.3333 29.1939 41.4531 28 36.6667 28C31.8802 28 28 29.1939 28 30.6667C28 32.1394 31.8802 33.3333 36.6667 33.3333Z" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M45.3333 36.668C45.3333 38.1408 41.4532 39.3346 36.6667 39.3346C31.8801 39.3346 28 38.1408 28 36.668" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M45.3333 30.668V42.4013C45.3333 44.0213 41.4532 45.3346 36.6667 45.3346C31.8801 45.3346 28 44.0213 28 42.4013V30.668" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M27.3307 24.0013C32.1172 24.0013 35.9974 22.8074 35.9974 21.3346C35.9974 19.8619 32.1172 18.668 27.3307 18.668C22.5443 18.668 18.6641 19.8619 18.6641 21.3346C18.6641 22.8074 22.5443 24.0013 27.3307 24.0013Z" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M23.9974 30.6667C21.475 30.3597 19.1573 29.566 18.6641 28M23.9974 37.3333C21.475 37.0264 19.1573 36.2327 18.6641 34.6667" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M23.9974 43.9987C21.475 43.6918 19.1573 42.898 18.6641 41.332V21.332" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M36 23.9987V21.332" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </div>
                                    <h5>Instant Settlement</h5>
                                    <small>Payments, savings and deductions processed seamlessly through Shelta’s payment rails.</small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="built-item-right">
                                    <div class="span-svg">
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M36.6667 33.3333C41.4531 33.3333 45.3333 32.1394 45.3333 30.6667C45.3333 29.1939 41.4531 28 36.6667 28C31.8802 28 28 29.1939 28 30.6667C28 32.1394 31.8802 33.3333 36.6667 33.3333Z" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M45.3333 36.668C45.3333 38.1408 41.4532 39.3346 36.6667 39.3346C31.8801 39.3346 28 38.1408 28 36.668" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M45.3333 30.668V42.4013C45.3333 44.0213 41.4532 45.3346 36.6667 45.3346C31.8801 45.3346 28 44.0213 28 42.4013V30.668" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M27.3307 24.0013C32.1172 24.0013 35.9974 22.8074 35.9974 21.3346C35.9974 19.8619 32.1172 18.668 27.3307 18.668C22.5443 18.668 18.6641 19.8619 18.6641 21.3346C18.6641 22.8074 22.5443 24.0013 27.3307 24.0013Z" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M23.9974 30.6667C21.475 30.3597 19.1573 29.566 18.6641 28M23.9974 37.3333C21.475 37.0264 19.1573 36.2327 18.6641 34.6667" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M23.9974 43.9987C21.475 43.6918 19.1573 42.898 18.6641 41.332V21.332" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M36 23.9987V21.332" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </div>
                                    <h5>Cross Eco-Integration</h5>
                                    <small>Connects directly to Shelta’s ecosystem — CoverPoint, COVA, Fixr, Watt and Renovate.</small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="built-item-right">
                                    <div class="span-svg">
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M36.6667 33.3333C41.4531 33.3333 45.3333 32.1394 45.3333 30.6667C45.3333 29.1939 41.4531 28 36.6667 28C31.8802 28 28 29.1939 28 30.6667C28 32.1394 31.8802 33.3333 36.6667 33.3333Z" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M45.3333 36.668C45.3333 38.1408 41.4532 39.3346 36.6667 39.3346C31.8801 39.3346 28 38.1408 28 36.668" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M45.3333 30.668V42.4013C45.3333 44.0213 41.4532 45.3346 36.6667 45.3346C31.8801 45.3346 28 44.0213 28 42.4013V30.668" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M27.3307 24.0013C32.1172 24.0013 35.9974 22.8074 35.9974 21.3346C35.9974 19.8619 32.1172 18.668 27.3307 18.668C22.5443 18.668 18.6641 19.8619 18.6641 21.3346C18.6641 22.8074 22.5443 24.0013 27.3307 24.0013Z" stroke="#0033EA" stroke-width="2"/>
                                            <path d="M23.9974 30.6667C21.475 30.3597 19.1573 29.566 18.6641 28M23.9974 37.3333C21.475 37.0264 19.1573 36.2327 18.6641 34.6667" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M23.9974 43.9987C21.475 43.6918 19.1573 42.898 18.6641 41.332V21.332" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M36 23.9987V21.332" stroke="#0033EA" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </div>
                                    <h5>Analytics & Reporting</h5>
                                    <small>Real-time data on participation, welfare impact and housing progress.</small>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mt-5 mb-5">
            <img class="w-100" src="../assets/cooperate/cooperate-base.png" alt="base">
        </div>

        <div class="who-can-join-holder">
            <h3>Who can join</h3>
            <h6>Shelta Corporate serves diverse organizations across Nigeria</h6>
            <div class="container">
                <div class="row">
                    <div class="col-md-4">
                        <div class="who-can-item">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M18.6641 34.6654C18.6641 30.9202 18.6641 29.0475 19.5629 27.7023C19.952 27.12 20.452 26.62 21.0344 26.2309C22.3795 25.332 24.2522 25.332 27.9974 25.332H35.9974C39.7426 25.332 41.6153 25.332 42.9605 26.2309C43.5427 26.62 44.0427 27.12 44.4319 27.7023C45.3307 29.0475 45.3307 30.9202 45.3307 34.6654C45.3307 38.4106 45.3307 40.2832 44.4319 41.6284C44.0427 42.2107 43.5427 42.7107 42.9605 43.0999C41.6153 43.9987 39.7426 43.9987 35.9974 43.9987H27.9974C24.2522 43.9987 22.3795 43.9987 21.0344 43.0999C20.452 42.7107 19.952 42.2107 19.5629 41.6284C18.6641 40.2832 18.6641 38.4106 18.6641 34.6654Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M37.3307 25.3333C37.3307 22.8192 37.3307 21.5621 36.5497 20.7811C35.7686 20 34.5115 20 31.9974 20C29.4833 20 28.2262 20 27.4451 20.7811C26.6641 21.5621 26.6641 22.8192 26.6641 25.3333" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M24 30.668L24.8693 30.9373C29.4468 32.356 34.5532 32.356 39.1307 30.9373L40 30.668M32 32.0013V34.668" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <h5>Employers & Institutions</h5>
                            <h6>Companies, schools, and agencies providing staff welfare programs</h6>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="who-can-item">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M36.6693 30.6667C36.6693 28.0893 34.5799 26 32.0026 26C29.4253 26 27.3359 28.0893 27.3359 30.6667C27.3359 33.244 29.4253 35.3333 32.0026 35.3333C34.5799 35.3333 36.6693 33.244 36.6693 30.6667Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M36.6388 31.1332C37.0681 31.2633 37.5234 31.3333 37.9952 31.3333C40.5725 31.3333 42.6618 29.244 42.6618 26.6667C42.6618 24.0893 40.5725 22 37.9952 22C35.5753 22 33.5856 23.8419 33.3516 26.2002" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M30.6462 26.2002C30.4122 23.8419 28.4225 22 26.0026 22C23.4253 22 21.3359 24.0893 21.3359 26.6667C21.3359 29.244 23.4253 31.3333 26.0026 31.3333C26.4744 31.3333 26.9297 31.2633 27.359 31.1332" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M45.3333 37.9987C45.3333 34.3168 42.0501 31.332 38 31.332" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M39.3307 41.9987C39.3307 38.3168 36.0475 35.332 31.9974 35.332C27.9473 35.332 24.6641 38.3168 24.6641 41.9987" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M25.9974 31.332C21.9473 31.332 18.6641 34.3168 18.6641 37.9987" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <h5>Cooperatives & Associations</h5>
                            <h6>Professional and staff groups managing member savings</h6>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="who-can-item">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M34.4722 45.3346C50.7685 41.3346 41.6425 25.3346 30.561 18.668C29.2578 23.3346 27.3019 24.668 23.3907 29.3346C18.2123 35.5132 20.7834 42.668 27.9537 45.3346C26.8673 44.0013 24.0635 41.2024 25.9974 37.3346C26.6641 36.0013 27.9974 34.668 27.3307 32.0013C28.6344 32.668 31.3307 33.3346 31.9974 36.668C33.0838 35.3346 34.2113 32.5346 33.1685 29.3346C41.3307 35.3346 37.9974 41.3346 34.4722 45.3346Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <h5>Faith & Community</h5>
                            <h6>Churches, unions and NGOs supporting members</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container household-holder mt-5">
            <h3>How To Get Started</h3>
            <h6>No complex setup. No lengthy training. Start empowering your people in minutes.</h6>

            <div class="mt-5">
                <div class="row">
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-md-10">
                                <div class="get-started">
                                    <div class="text-left mb-4">
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="64" height="64" rx="32" fill="white"/>
                                            <path d="M36 28.5C36 26.2909 34.2092 24.5 32 24.5C29.7908 24.5 28 26.2909 28 28.5C28 30.7092 29.7908 32.5 32 32.5C34.2092 32.5 36 30.7092 36 28.5Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M45.3307 32.5013C45.3307 25.1375 39.3611 19.168 31.9974 19.168C24.6336 19.168 18.6641 25.1375 18.6641 32.5013C18.6641 39.865 24.6336 45.8346 31.9974 45.8346C39.3611 45.8346 45.3307 39.865 45.3307 32.5013Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M38.6693 39.1667C38.6693 35.4848 35.6845 32.5 32.0026 32.5C28.3207 32.5 25.3359 35.4848 25.3359 39.1667" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>

                                    </div>
                                    <div>
                                        <h1>Create Your Profile</h1>
                                        <h2>Create a corporate, cooperative, or association profile.</h2>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="col-md-2 m-auto">
                                <span>
                                    <i class="fa fa-chevron-right" :class="isMobile ? 'fa-chevron-down' : ''"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-md-10">
                                <div class="get-started">
                                    <div class="text-left mb-4">
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="64" height="64" rx="32" fill="white"/>
                                            <path d="M19.3359 28.5H24.6693" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M19.3359 35.168H24.6693" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M19.3359 21.832H40.6693" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M40.7166 39.2127L44.6693 43.1654M42.6693 34.4987C42.6693 30.8168 39.6845 27.832 36.0026 27.832C32.3207 27.832 29.3359 30.8168 29.3359 34.4987C29.3359 38.1806 32.3207 41.1654 36.0026 41.1654C39.6845 41.1654 42.6693 38.1806 42.6693 34.4987Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div>
                                        <h1>Choose Programs</h1>
                                        <h2>Select Flexible Rent, Rent-to-Own, or Staff Housing options. </h2>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2 m-auto">
                                <span>
                                    <i class="fa fa-chevron-right" :class="isMobile ? 'fa-chevron-down' : ''"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="get-started">
                                    <div class="text-left mb-4">
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="64" height="64" rx="32" fill="white"/>
                                            <path d="M40 27C42.2091 27 44 25.2091 44 23C44 20.7909 42.2091 19 40 19C37.7909 19 36 20.7909 36 23C36 25.2091 37.7909 27 40 27Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M24 45.832C26.2091 45.832 28 44.0412 28 41.832C28 39.6229 26.2091 37.832 24 37.832C21.7909 37.832 20 39.6229 20 41.832C20 44.0412 21.7909 45.832 24 45.832Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M32.3333 23H27.6667C25.0893 23 23 25.0893 23 27.6667C23 30.244 25.0893 32.3333 27.6667 32.3333H37C39.5773 32.3333 41.6667 34.4227 41.6667 37C41.6667 39.5773 39.5773 41.6667 37 41.6667H32.3333" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div>
                                        <h1>Onboard & Track</h1>
                                        <h2>Add members and track participation in real-time</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="trusted-by">
            <div clsass="">
                <div class="household-holder mt-5">
                    <h3>Trusted by Forward-Thinking Organizations and Cooperatives</h3>
                    <h6>Real stories from partners who are empowering their people through Shelta.</h6>
                </div>
                <div class="container" style="margin-top: 60px;">
                    <div class="row flex-sm-nowrap overflow-auto">
                        <div class="col-12 col-sm-4 col-md-4">
                            <div class="org-trusted-item">
                                <h4>“We moved from staff housing stress to real stability.”</h4>
                                <h6>Integrating Shelta into our welfare program transformed how our team handles rent and housing. Staff can now pay rent monthly while we stay hands-off yet more engaged. It’s a game changer for retention and morale.</h6>
                                <div class="row mt-4 mb-4" style="align-items: center;">
                                    <div>
                                        <img src="../assets/icons/profile-icon.svg" alt="profile">
                                    </div>
                                    <div>
                                        <h5>Tunde Adebayo</h5>
                                        <p>HR Manager, FirstLink Insurance Ltd</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4 col-md-4">
                            <div class="org-trusted-item">
                                <h4>“We moved from staff housing stress to real stability.”</h4>
                                <h6>Integrating Shelta into our welfare program transformed how our team handles rent and housing. Staff can now pay rent monthly while we stay hands-off yet more engaged. It’s a game changer for retention and morale.</h6>
                                <div class="row mt-4 mb-4" style="align-items: center;">
                                    <div>
                                        <img src="../assets/icons/profile-icon.svg" alt="profile">
                                    </div>
                                    <div>
                                        <h5>Tunde Adebayo</h5>
                                        <p>HR Manager, FirstLink Insurance Ltd</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4 col-md-4">
                            <div class="org-trusted-item">
                                <h4>“We moved from staff housing stress to real stability.”</h4>
                                <h6>Integrating Shelta into our welfare program transformed how our team handles rent and housing. Staff can now pay rent monthly while we stay hands-off yet more engaged. It’s a game changer for retention and morale.</h6>
                                <div class="row mt-4 mb-4" style="align-items: center;">
                                    <div>
                                        <img src="../assets/icons/profile-icon.svg" alt="profile">
                                    </div>
                                    <div>
                                        <h5>Tunde Adebayo</h5>
                                        <p>HR Manager, FirstLink Insurance Ltd</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4 col-md-4">
                            <div class="org-trusted-item">
                                <h4>“We moved from staff housing stress to real stability.”</h4>
                                <h6>Integrating Shelta into our welfare program transformed how our team handles rent and housing. Staff can now pay rent monthly while we stay hands-off yet more engaged. It’s a game changer for retention and morale.</h6>
                                <div class="row mt-4 mb-4" style="align-items: center;">
                                    <div>
                                        <img src="../assets/icons/profile-icon.svg" alt="profile">
                                    </div>
                                    <div>
                                        <h5>Tunde Adebayo</h5>
                                        <p>HR Manager, FirstLink Insurance Ltd</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4 col-md-4">
                            <div class="org-trusted-item">
                                <h4>“We moved from staff housing stress to real stability.”</h4>
                                <h6>Integrating Shelta into our welfare program transformed how our team handles rent and housing. Staff can now pay rent monthly while we stay hands-off yet more engaged. It’s a game changer for retention and morale.</h6>
                                <div class="row mt-4 mb-4" style="align-items: center;">
                                    <div>
                                        <img src="../assets/icons/profile-icon.svg" alt="profile">
                                    </div>
                                    <div>
                                        <h5>Tunde Adebayo</h5>
                                        <p>HR Manager, FirstLink Insurance Ltd</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4 col-md-4">
                            <div class="org-trusted-item">
                                <h4>“We moved from staff housing stress to real stability.”</h4>
                                <h6>Integrating Shelta into our welfare program transformed how our team handles rent and housing. Staff can now pay rent monthly while we stay hands-off yet more engaged. It’s a game changer for retention and morale.</h6>
                                <div class="row mt-4 mb-4" style="align-items: center;">
                                    <div>
                                        <img src="../assets/icons/profile-icon.svg" alt="profile">
                                    </div>
                                    <div>
                                        <h5>Tunde Adebayo</h5>
                                        <p>HR Manager, FirstLink Insurance Ltd</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="partnership-holder">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div>
                            <h4>Shelta for Corporate is more than a platform — it’s a partnership.</h4>
                            <h6>It’s how modern organizations and cooperatives help their people live better, own better and grow together, powered by Africa’s first integrated household service infrastructure.</h6>
                            <div class="join-btn d-none d-sm-block">
                                <button class="btn" @click="moveToRouteName('https://corporate.myshelta.com/dashboard')">Get started</button>
                                <button class="btn no-button" @click="moveToRouteName2('/contactus')">Contact Support</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <img class="w-100" src="../assets/cooperate/unison.png" alt="unison">
                        </div>

                        <div class="join-btn  d-block d-sm-none">
                            <button class="btn">Get started</button>
                            <button class="btn no-button">Contact Support</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterMain />
    </div>
</template>


<script>
import FooterMain from "../views/FooterMain";
import Header from "../views/Header";
export default {
  name: "Cooperate",
  components: {
    Header,
    FooterMain,
    // HomePart,
    // PromoGif
  },
  data() {
    return {
        isMobile: false,
    };
  },
  created() {
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreen);
  },
  mounted() {
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth <= 768; // your breakpoint
    },
    moveToRouteName(route) {
        window.open(route, '_blank');
    },
    moveToRouteName2(route) {
        // window.open(route, '_blank');
        this.$router
          .push({
            path: route
        })
        .catch(() => {});
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>

.top-holder {
    margin-top: 6rem;
    padding-top: 4rem;
    padding-bottom: 4rem;
    // background: linear-gradient(270deg, #E0F2F7 0%, #F0F8FF 50%, #FFFFFF 100%), url(../assets/cooperate/cooperate-bg.png);
    background: url(../assets/cooperate/cooperate-bg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    position: relative;
}

.top-holder::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.85); /* White overlay with 50% opacity */
    /* Adjust the '0.5' (alpha value) from 0.0 (fully transparent) to 1.0 (fully opaque) */
}

.top-left {
    h6 {
        background: #FFB100;
        color: #ffffff;
        border-radius: 50px;
        padding: 8px 30px;
        min-height: 35px;
        margin-bottom: 20px;
        font-family: Lato;
        font-weight: 400;
        font-size: 18px;
        line-height: 30px;
        width: fit-content;
        text-align: left;
    }
    h3 {
        font-family: Lato;
        font-weight: 700;
        // font-style: Bold;
        font-size: 32px;
        line-height: 50px;
        text-align: left;
        color: #1A1A1A;
        margin-bottom: 20px;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #555555;
        text-align: left;
    }

}

.join-btn {
        margin-top: 7rem;
        text-align: left;
        button:first-child {
            background: #0033EA;
            color: #ffffff;
            font-family: Lato;
            font-weight: 500;
            font-size: 16px;
            outline: 0;
            box-shadow: none;
        }
        button:nth-child(2) {
            color: #0033EA;
            // color: blue !important;
            font-family: Lato;
            font-weight: 500;
            font-size: 16px;
            outline: 0;
            box-shadow: none;
        }
}

.count-holder {
    // #EBEBEB
    position: relative;
    margin-top: 2rem;
    h2 {
        font-family: Lato;
        font-weight: 700;
        font-size: 18px;
        // line-height: 40px;
        text-align: left;
        color: #0033EA;
        // margin-bottom: 0;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        text-align: left;
        color: #555555;
        // margin-bottom: 0;
    }
    .item-count {
        background: #FFFFFF;
        padding: 16px 24px;
        border-radius: 16px;
        .col-md-6 {
            padding: 12px 24px;
        }
        // .col-md-6:not(:last-child) {
        //     border-right: 1px solid #EBEBEB;
        //     padding-right: 4rem;
        // }
    }
}
.first-col {
    border-right: 1px solid #EBEBEB;
    // padding-right: 4rem;
    
}

.partners-holder {
    margin-top: 8rem;
    margin-bottom: 7rem;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        color: #1F2223;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 18px;
        text-align: center;
        color: #555555
    }
}

.primary-button {
    margin-top: 25px;
    button {
        background-color: #0033EA;
        color: #FFFFFF;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        outline: 0;
        box-shadow: none;
    }
}

.scroller {
  /* Set a specific width to define the viewport for the scrolling area */
  width: 100%;
  overflow: hidden; /* Hide the overflowing content */
  /* Optional: adds fade effect at the edges */
  mask: linear-gradient(90deg, transparent, white 20%, white 80%, transparent);
}

/* Inner container that holds the logo lists */
.scroller-inner {
  display: flex;
  /* Combine the two <ul> elements side-by-side */
  width: max-content; 
  /* Run the animation */
  animation: scroll-left 20s linear infinite; /* Adjust duration to control speed */
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Pause the animation on hover */
.scroller:hover .scroller-inner {
  animation-play-state: paused;
}

/* Styles for individual logo items */
.scroller-inner li {
  /* Adjust spacing between logos as needed */
  margin: 0 1rem; 
  /* Ensure images do not wrap to the next line */
  white-space: nowrap;
}

/* Optional: style for the images themselves */
.scroller-inner img {
  max-width: none;
  height: 50px; /* Adjust image height as desired */
}

/* Keyframe animation for the leftward scroll */
@keyframes scroll-left {
  0% {
    /* Start position */
    transform: translateX(0);
  }
  100% {
    /* Move left by 50% of the total width (the width of one <ul>) */
    transform: translateX(-100%); 
  }
}

@media (max-width: 767px) { /* Adjust breakpoint as needed for "mobile" */
  .container > *:not(:last-child) {
    border-right: none;
  }
  .count-holder {
    // #EBEBEB
        div:not(:last-child) {
            border-right: none;
            padding-right: 0;
        }

    }
}
.solved-problem {
    margin-top: 10rem !important;
    padding: 60px 0;
}

.household-holder, .solved-problem {
    // margin-top: 4rem;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        color: #1F2223;
        line-height: 42px;
        padding-left: 15px;
        padding-right: 15px;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 18px;
        text-align: center;
        color: #555555;
        line-height: 28px;
    }
}

.problem-cover {
    text-align: left;
    margin-top: 5rem;
    margin-bottom: 5rem;
    padding: 0 15px;
}

.problem-item {
    border-radius: 16px;
    border: 2px solid #EBEBEB;
    padding: 25px;
    min-height: 246px;
    margin-bottom: 15px;
    h5 {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        color: #1A1A1A;
        text-align: left;
        margin-top: 10px;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-style: Regular;
        font-size: 14px;
        line-height: 22px;
        color: #555555;
        text-align: left;
    }

}

.household-image {
    svg {
        width: 100%;
        height: 100%;
    }
}

.why-matters-holder {
    background: #ffffff;
    padding: 80px 0;
}

.matters-item {
    h2 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        line-height: 42px;
        color: #1A1A1A;
        text-align: left;
        margin-bottom: 40px;
        line-height: 42px;
    }
    small {
        color:#0033EA;
        display: flex;
    }
    p {
        color: #555555;
    }
    p, small {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        text-align: left;
    }

    .primary-button {
        display: flex;
        margin-top: 50px;
    }
}

.org-partner {
    // padding: 0 15px;
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #1A1A1A;
        text-align: left;
        margin-bottom: 40px;
    }
}

.built-for-org-holder {
    background: #F8F9FA;
    padding: 60px 0;
}
.org-partner-item {
    border: 1.5px solid #EBEBEB;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 20px;
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #555555;
        text-align: left;
        padding-left: 20px;
        margin-bottom: 0;
    }
}

.built-item-left {
    h2 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
        color: #1A1A1A;
        text-align: left;
        margin-bottom: 40px;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        color: #555555;
        text-align: left;
    }
}
.built-item-right {
    border: 1.5px solid #EBEBEB;
    padding: 24px;
    border-radius: 16px;
    margin-bottom: 20px;
    .span-svg {
        display: flex;
    }
    h5 {
        font-family: Lato;
        font-weight: 500;
        text-align: left;
        font-size: 18px;
        line-height: 25px;
        color: #1A1A1A;
    }
    small {
        font-family: Lato;
        font-weight: 400;
        text-align: left;
        font-size: 14px;
        line-height: 22px;
        color: #555555;
        display: flex;
    }
}
.who-can-join-holder {
    background: #F8F9FA;
    padding: 120px 0 100px 0;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        line-height: 30px;
        color: #1A1A1A;
        text-align: center;
        margin-bottom: 20px;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        color: #555555;
        text-align: center;
        margin-bottom: 80px;
    }
}
.trusted-by {
    .household-holder {
        h3 {
            font-size: 27px !important;
        }
    }
}

.household-holder {
    h3 {
        font-size: 31px;
    }
}
.who-can-item {
    background: #FFFFFF;
    padding: 32px;
    border-radius: 16px;
    margin-bottom: 20px;
    h5 {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        color: #1A1A1A;
        text-align: center;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: #555555;
        text-align: center;
    }
}

.get-started {
    margin-bottom: 20px;
    background: #F8F9FA;
    padding: 32px 20px;
    border-radius: 16px;
    text-align: left;
    h1 {
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 20px;
        color: #000000;
        text-align: left;
    }
    h2 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #3A3A3A;
        text-align: left;
    }
}

.trusted-by {
    background: #F8F9FA;
    padding: 16px 0 80px 0;
    margin-top: 100px;
    // margin-bottom: 60px;
}

.org-trusted-item {
    background: #ffffff;
    padding: 32px;
    border-radius: 16px;
    margin-bottom: 20px;
    img {
        width: 100%;
        object-fit: cover;
        border-radius: 50px;
        border: 2px solid #EBEBEB;
        width: 75px;
        height: 75px;
        margin-right: 10px;
    }
    h4 {
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        line-height: 23px;
        color: #3A3A3A;
        text-align: left;
        // margin-bottom: 0;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 23px;
        color: #3A3A3A;
        text-align: left;
        // margin-bottom: 0;
    }
    h5 {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 23px;
        color: #0C0C0C;
        text-align: left;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        text-align: left;
        font-size: 14px;
        line-height: 23px;
        color: #3A3A3A;
        margin-bottom: 0;
    }

}

.overflow-auto {
    overflow-x: auto;
    overflow-y: hidden; /* Hide vertical scrollbar */
}


.partnership-holder {
    background: url(../assets/cooperate/cooperate-bg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    margin-bottom: 50px;
    position: relative;
    padding: 40px 0;
    // box-shadow: 0px 4px 4px 0px #0033EA0D;

    h4 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        text-align: left;
        color: #1A1A1A;
        margin-bottom: 40px;
        line-height: 45px;
    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        text-align: left;
        line-height: 28px;
        color: #555555;

    }

}
.partnership-holder::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.5); /* White overlay with 50% opacity */
    box-shadow: 0px 4px 4px 0px #0033EA0D;
    /* Adjust the '0.5' (alpha value) from 0.0 (fully transparent) to 1.0 (fully opaque) */
}

@media (max-width: 767px) {
    .solved-problem {
        padding-bottom: 20px;
        h3 {
            font-size: 31px;
        }
    }
    .matters-item {
        // padding: 20px;
        h2 {
            font-size: 31px;
            margin-bottom: 25px;
        }
    }
    .org-partner {
        h6 {
            margin-top: 40px;
        }
    }
    .why-matters-holder {
        padding-top: 24px;
    }
    .built-for-org-holder {
        padding: 60px 0 10px 0;
    }
    .built-item-left {
        h2 {
            font-size: 31px;
        }
    }
    .who-can-join-holder {
        padding-top: 50px;
        h3 {
            font-size: 31px;
        }
    }
    .org-trusted-item {
        img {
            margin-top: 10px;
        }
        h5 {
            margin-top: 20px
        }
    }
    .partnership-holder {
        h4 {
            font-size: 31px;
        }
        h6 {
            margin-bottom: 30px;
        }
    }
    .partners-holder {
        margin-top: 4rem;
    }
    .top-left {
        h3 {
            line-height: 41px;
            font-size: 31px;
        }
        p {
            margin-bottom: 40px;
        }
        h6 {
            font-size: 13px;
        }
    }
}


</style>